<template>
  <div>
    <ul
      class=""
      id="categorySlider"
      v-if="cat === 'sub'"
      ref="categoryCarousel"
    >
      <li v-for="sub in sliderData" :key="sub.key">
        <router-link
          class="mobislider__crcElm_a4all"
          :to="{
            name: 'Subcategory',
            params: { category: category, subcat: sub.route }
          }"
        >
          <!-- <img class="icons" :src="sub.icon" alt="">  -->
          <span :class="sub.icon"></span>
        </router-link>
        <p class="mobislider__catLabel text_color1">
          <span>{{ sub[`titleSub_${lang_a4all}`] }}</span>
        </p>
      </li>
    </ul>
    <div v-if="cat === 'hot'">
      <div v-if="category === 'video'">
        <div class="row" ref="hotCarousel">
          <div
            v-for="hot in hotpick"
            :key="hot.key"
            class="col-6 col-md-3 col-lg-2 col-sm-4 mobiColItem"
          >
            <router-link
              class="browse_link mobiVideo"
              :to="{
                name: 'DetailPage',
                params: { id: hot.content_id }
              }"
            >
              <div class="mobiVideo__thumb">
                <img class="img_wrp" :src="hot.cover_img" alt="" />
              </div>
              <div class="playBtn"><span></span></div>
              <div class="mobiVideo__info">
                <!-- <h3 class="mobiTitle sm">{{ hot.content_name }}</h3> -->
                <span v-if="lang_a4all !== 'english'">
                  <h3 class="mobiTitle sm" v-if="hot[`cont_name_${lang_a4all}`] !== ''">{{ hot[`cont_name_${lang_a4all}`] }}</h3>
                  <h3 class="mobiTitle sm" v-else>{{ hot[`cont_name_english`] }}</h3>
                </span>
                <span v-else>
                  <h3 class="mobiTitle sm">{{ hot[`cont_name_english`] }}</h3>
                </span>
                <div>
                  <!-- <p>{{ hot.total_download }} {{$t("downloads")}}</p> -->
                  <star-rating
                    :inline="true"
                    :star-size="16"
                    :read-only="true"
                    :increment="0.01"
                    active-color="#ffe000"
                    :show-rating="false"
                    :border-width="2"
                    border-color="#ffe000"
                    :rounded-corners="false"
                    inactive-color="#00923d"
                    :star-points="[
                      23,
                      2,
                      14,
                      17,
                      0,
                      19,
                      10,
                      34,
                      7,
                      50,
                      23,
                      43,
                      38,
                      50,
                      36,
                      34,
                      46,
                      19,
                      31,
                      17
                    ]"
                    :rating="Number(hot.rating)"
                  ></star-rating>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="row" ref="hotCarousel">
          <div
            v-for="hot in hotpick"
            :key="hot.key"
            class="col-6 col-md-3 col-lg-2 col-sm-4 mobiColItem"
          >
          
            <router-link
              class="browse_link mobiApp"
              :to="{
                name: 'DetailPage',
                params: { id: hot.content_id }
              }"
            >
             <div v-if="hot.content_type === 'application/x-zip-compressed' && hot.parent_category === 'Game'" class="mobibadge badge--html5">
                    <img src="../../assets/funplus/imgs/html5-badge.png"/>
                   
                  </div>
              <div class="mobiApp__thumb">
                <img class="img_wrp" :src="hot.thumbnail_url" alt="" />
                 
              </div>
              <div class="mobiApp__info">
                <!-- <h3 class="mobiTitle sm text_color1">{{ hot.content_name }}</h3> -->
                <span v-if="lang_a4all !== 'english'">
                  <h3 class="mobiTitle sm text_color1" v-if="hot[`cont_name_${lang_a4all}`] !== ''">{{ hot[`cont_name_${lang_a4all}`] }}</h3>
                  <h3 class="mobiTitle sm text_color1" v-else>{{ hot[`cont_name_english`] }}</h3>
                </span>
                <span v-else>
                  <h3 class="mobiTitle sm text_color1">{{ hot[`cont_name_english`] }}</h3>
                </span>
                <div>
                  <!-- <p>{{ hot.total_download }} {{$t("downloads")}}</p> -->
                  <star-rating
                    :inline="true"
                    :star-size="16"
                    :read-only="true"
                    :increment="0.01"
                    active-color="#ffe000"
                    :show-rating="false"
                    :border-width="3"
                    border-color="#ffe000"
                    :rounded-corners="false"
                    inactive-color="#00923d"
                    :star-points="[
                      23,
                      2,
                      14,
                      17,
                      0,
                      19,
                      10,
                      34,
                      7,
                      50,
                      23,
                      43,
                      38,
                      50,
                      36,
                      34,
                      46,
                      19,
                      31,
                      17
                    ]"
                    :rating="Number(hot.rating)"
                  ></star-rating>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div v-if="cat === 'pop'">
      <div v-if="category === 'video'">
        <div class="row" ref="popularCarousel">
          <div
            v-for="pop in popular"
            :key="pop.key"
            class="col-12 col-md-4 col-lg-4 col-sm-6 mobiColItem"
          >
            <router-link
              class="browse_link mobiVideo"
              :to="{
                name: 'DetailPage',
                params: { id: pop.content_id }
              }"
            >
              <div class="mobiVideo__thumb">
                <img class="img_wrp" :src="pop.cover_img" alt="" />
              </div>
              <div class="playBtn"><span></span></div>
              <div class="mobiVideo__info">
                <!-- <h3 class="mobiTitle sm">{{ pop.content_name }}</h3>-->
                <span v-if="lang_a4all !== 'english'">
                  <h3 class="mobiTitle sm" v-if="pop[`cont_name_${lang_a4all}`] !== ''">{{ pop[`cont_name_${lang_a4all}`] }}</h3>
                  <h3 class="mobiTitle sm" v-else>{{ pop[`cont_name_english`] }}</h3>
                </span>
                <span v-else>
                  <h3 class="mobiTitle sm">{{ pop[`cont_name_english`] }}</h3>
                </span>
                <div>
                  <!-- <p>{{ pop.total_download }} {{$t("downloads")}}</p> -->
                  <star-rating
                    :inline="true"
                    :star-size="16"
                    :read-only="true"
                    :increment="0.01"
                    active-color="#ffe000"
                    :show-rating="false"
                    :border-width="2"
                    border-color="#ffe000"
                    :rounded-corners="false"
                    inactive-color="#00923d"
                    :star-points="[
                      23,
                      2,
                      14,
                      17,
                      0,
                      19,
                      10,
                      34,
                      7,
                      50,
                      23,
                      43,
                      38,
                      50,
                      36,
                      34,
                      46,
                      19,
                      31,
                      17
                    ]"
                    :rating="Number(pop.rating)"
                  ></star-rating>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="row" ref="popularCarousel">
          <div
            v-for="pop in popular"
            :key="pop.key"
            class="col-6 col-md-3 col-lg-2 col-sm-4 mobiColItem "
          >
           
            <router-link
              class="browse_link mobiApp"
              :to="{
                name: 'DetailPage',
                params: { id: pop.content_id }
              }"
            >
                  <div v-if="pop.content_type === 'application/x-zip-compressed' && pop.parent_category === 'Game'" class="mobibadge badge--html5">
                    <img src="../../assets/funplus/imgs/html5-badge.png"/>
                  </div>
              <div class="mobiApp__thumb">
                <img class="img_wrp" :src="pop.thumbnail_url" alt="" />
                   
              </div>
              <div class="mobiApp__info">
                <!-- <h3 class="mobiTitle sm text_color1">{{ pop.content_name }}</h3> -->
                <span v-if="lang_a4all !== 'english'">
                  <h3 class="mobiTitle sm text_color1" v-if="pop[`cont_name_${lang_a4all}`] !== ''">{{ pop[`cont_name_${lang_a4all}`] }}</h3>
                  <h3 class="mobiTitle sm text_color1" v-else>{{ pop[`cont_name_english`] }}</h3>
                </span>
                <span v-else>
                  <h3 class="mobiTitle sm text_color1">{{ pop[`cont_name_english`] }}</h3>
                </span>
                <div>
                  <!-- <p>{{ pop.total_download }} {{$t("downloads")}}</p> -->
                  <star-rating
                    :inline="true"
                    :star-size="16"
                    :read-only="true"
                    :increment="0.01"
                    active-color="#ffe000"
                    :show-rating="false"
                    :border-width="3"
                    border-color="#ffe000"
                    :rounded-corners="false"
                    inactive-color="#00923d"
                    :star-points="[
                      23,
                      2,
                      14,
                      17,
                      0,
                      19,
                      10,
                      34,
                      7,
                      50,
                      23,
                      43,
                      38,
                      50,
                      36,
                      34,
                      46,
                      19,
                      31,
                      17
                    ]"
                    :rating="Number(pop.rating)"
                  ></star-rating>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import StarRating from 'vue-star-rating';
import Flickity from "flickity";
export default {
  data() {
    return {
      flickityOptions: {
        dragThreshold: 50,
        initialIndex: 0,
        prevNextButtons: true,
        pageDots: false,
        cellAlign: "left",
        resize: true,
        hash: true,
        percentPosition: false,
      },
      flickityOptionsCategory: {
        dragThreshold: 50,
        initialIndex: 0,
        prevNextButtons: true,
        pageDots: false,
        groupCells: false,
        wrapAround: true,
        resize: true,
        hash: true,
        percentPosition: false,
      },
      stageDragging: false,
      cate: {
        hot: "hot",
        pop: "pop",
        sub: "sub",
      },
    };
  },
  computed: mapGetters(["lang_a4all", "country_a4all"]),
  props: ["sliderData", "cat", "hotpick", "popular", "category", "isLoaded"],
  mounted() {
    let sliderStatus = false;
    let width = window.innerWidth;
  },
  components:{
    StarRating
  },
  methods: {
    triggerFn(sliderType) {
      setTimeout(() => {
        switch (sliderType) {
          case "catSlider":
            const categorySliderflkty = new Flickity(
              this.$refs.categoryCarousel,
              this.flickityOptionsCategory
            );
            categorySliderflkty.on("dragStart", function () {
              this.stageDragging = true;
            });
            categorySliderflkty.on("dragEnd", function () {
              this.stageDragging = false;
            });
            break;
          case "hotPicksSlider":
            this.$nextTick(() => {
              const hotPickSliderflkty = new Flickity(
                this.$refs.hotCarousel,
                this.flickityOptions
              );
              hotPickSliderflkty.on("dragStart", function () {
                this.stageDragging = true;
              });
              hotPickSliderflkty.on("dragEnd", function () {
                this.stageDragging = false;
              });
            });
            break;
          case "popularSlider":
            this.$nextTick(() => {
              const popularSliderflkty = new Flickity(
                this.$refs.popularCarousel,
                this.flickityOptions
              );
              popularSliderflkty.on("dragStart", function () {
                this.stageDragging = true;
              });
              popularSliderflkty.on("dragEnd", function () {
                this.stageDragging = false;
              });
            });
          case "arSlider":
            this.$nextTick(() => {
              const arSliderflkty = new Flickity(
                this.$refs.categoryCarousel,
                this.flickityOptions
              );
              arSliderflkty.on("dragStart", function () {
                this.stageDragging = true;
              });
              arSliderflkty.on("dragEnd", function () {
                this.stageDragging = false;
              });
            });
          default:
        }
      }, 0);
    },
  },
};
</script>
<style lang="scss">
/*###App Slider styles###*/

.apps4all {
  .mobislider {
    position: relative;
    ul {
      list-style: none;
      padding: 0;
      margin: 0;
      display: flex;
      width: 100%;
      justify-content: space-between;
    }
    li {
      // display: inline-block;
      text-align: center;
      width: 20%;
    }
    &:before,
    &:after {
      content: "";
      position: absolute;
      height: 100%;
      width: 52px;
      background-color: #fff;
      top: 0;
      z-index: 2;
    }
    &:before {
      left: -10px;
      background: rgb(255, 255, 255);
      background: linear-gradient(
        270deg,
        rgba(10, 164, 74, 0%) 46%,
        rgb(10, 164, 74) 100%
      );
    }
    &:after {
      right: -10px;
      background: linear-gradient(
        270deg,
        rgb(10, 164, 74) 46%,
        rgba(10, 164, 74, 0%) 100%
      );
    }
  }

  .sliderWrap {
    position: relative;
    &:before,
    &:after {
      content: "";
      position: absolute;
      height: 100%;
      width: 52px;
      background-color: #fff;
      top: 0;
      z-index: 2;
    }
    &:before {
      left: -20px;
      background: #fff;
      background: linear-gradient(
        270deg,
        rgba(10, 164, 74, 0%) 46%,
        rgb(10, 164, 74) 100%
      );
    }
    &:after {
      right: -20px;
      background: linear-gradient(
        270deg,
        rgb(10, 164, 74) 46%,
        rgba(10, 164, 74, 0%) 100%
      );
    }
  }
  .mobislider__crcElm_a4all {
    display: block;
    background: #00ec62;
    color: #fff;
    width: 68px;
    height: 68px;
    border-radius: 50%;
    line-height: 68px;
    margin: 0 auto;
    text-align: center;
    img {
      width: 42px;
    }
    span {
      &::before {
        font-size: 3rem;
        margin-left: 0px;
        font-weight: 400;
      }
    }
    &:hover {
      text-decoration: none;
      color: #fff;
    }
  }
  .mobislider__catLabel {
    font-size: 1rem;
    margin: 15px 0;
    font-weight: 500;
  }
  .flickity-viewport {
    width: 100%;
  }
  .mobislider .flickity-button,
  .sliderWrap .flickity-button {
    z-index: 3;
    background-color: #f3f3f3;
  }
  .mobislider .flickity-prev-next-button.next,
  .sliderWrap .flickity-prev-next-button.next {
    right: -3%;
  }
  .mobislider .flickity-prev-next-button.previous,
  .sliderWrap .flickity-prev-next-button.previous {
    left: -3%;
  }
}
.text_color1 {
  color: white;
}

.ar_layout {
  .mobislider__catLabel {
    text-align: center !important;
    font-size: 1.2rem;
    font-weight: 600;
  }
}
/*##### Responsive layout Styles#####*/
@media only screen and (max-width: 991px) {
  .mobislider .flickity-prev-next-button.next,
  .sliderWrap .flickity-prev-next-button.next {
    right: 0;
  }
  .mobislider .flickity-prev-next-button.previous,
  .sliderWrap .flickity-prev-next-button.previous {
    left: 0;
  }
  .sliderWrap:before,
  .sliderWrap:after {
    display: none;
  }
  .mobislider li {
    width: 15%;
  }
}

@media only screen and (max-width: 589px) {
  .sliderWrap {
    .mobiApp__info {
      text-align: left;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/apps4all/Apps4allSlider.vue